// request.js
import axios from 'axios';

// axios.defaults.headers.post['content-type']='application/x-www-form-urlencoded;charset=UTF-8'
// axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8'
// post请求
function postRequest(url, data = {}, method = 'post') {
    let paramas = '';
    for (let key in data) {
        paramas += key + '=' + data[key] + '&'
    }
    let header = {
        'Content-Type': 'application/json',
        
    }
    
   
    let datas = '?' + paramas //+datas
    return new Promise((resolve, reject) => {
        axios({
            url: url + datas,
            method: method,
            headers: header,
            data,
        })
            .then(res => {
                //成功
                resolve(res.data)
            })
            .catch(res => {
                //失败
                reject(res)
            })

    })
}

export default {
    postRequest,
}


// WEBPACK FOOTER //
// ./src/util/request.js